
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7 5C7 4.44772 7.44772 4 8 4C8.55228 4 9 4.44772 9 5V10H15V5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5V10H20C21.1046 10 22 10.8954 22 12V13.5278C20.9385 12.5777 19.5367 12 18 12C16.223 12 14.6264 12.7725 13.5278 14H11C10.4477 14 10 14.4477 10 15C10 15.5523 10.4477 16 11 16H12.3414C12.1203 16.6256 12 17.2987 12 18C12 18.7013 12.1203 19.3744 12.3414 20H4C2.89543 20 2 19.1046 2 18V12C2 10.8954 2.89543 10 4 10H7V5ZM4 15C4 14.4477 4.44772 14 5 14C5.55228 14 6 14.4477 6 15C6 15.5523 5.55228 16 5 16C4.44772 16 4 15.5523 4 15ZM7 15C7 14.4477 7.44772 14 8 14C8.55228 14 9 14.4477 9 15C9 15.5523 8.55228 16 8 16C7.44772 16 7 15.5523 7 15Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M17.0367 18C16.3122 17.6869 15.4712 17.1784 14.6465 16.3536L15.3536 15.6465C16.2903 16.5832 17.2375 17.0454 17.942 17.2746C18.2951 17.3894 18.5877 17.4458 18.7879 17.4735C18.888 17.4874 18.9646 17.494 19.0139 17.4972C19.0385 17.4988 19.0562 17.4995 19.0666 17.4998L19.0765 17.5C19.0764 17.5 19.0765 17.5 19.0765 17.5L20.7929 17.5L20.1465 16.8536L20.8536 16.1465L22.7071 18L20.8536 19.8536L20.1465 19.1465L20.7929 18.5H19.0766L19.0666 18.5003C19.0562 18.5006 19.0385 18.5013 19.0139 18.5029C18.9646 18.5061 18.888 18.5127 18.7879 18.5266C18.5877 18.5543 18.2951 18.6107 17.942 18.7255C17.2375 18.9546 16.2903 19.4169 15.3536 20.3536L14.6465 19.6465C15.4712 18.8217 16.3122 18.3131 17.0367 18Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowgatewaymergeFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
